import { Button, Form, Select } from "antd";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/store";
import SelectDropdownLgIcon from "../../assets/icons/SelectDropdownLgIcon";
import { useGetTagListQuery } from "../../features/organization/job/jobApi";
import useError from "../../hooks/useError";
import { selectSearchOption, selectStringOption } from "../../utils/utils";

type Props = {
  type?: "view";
};

export default function BalanceCard({ type }: Props) {
  const { id } = useParams();
  const { user } = useAppSelector((state) => state.auth);
  const {
    data: getTagData,
    isError: isTagError,
    error: tagError,
    isLoading: isTagLoading,
  } = useGetTagListQuery({
    params: {
      business_id: user?.business_id,
    },
  });
  useError(isTagError, tagError, "Tags get fail");

  return (
    <div className="">
      {/* <div className="p-4 bg-gradient-to-tl from-fuchsia-600 to-cyan-400 rounded-tl-lg rounded-tr-lg text-white">
        <h2 className="text-3xl font-medium leading-[48px]">0</h2>
        <p className="text-base text-white font-normal leading-tight">
          Current balance (BDT)
        </p>

        <div className="mt-2.5 flex items-center">
          <PayIcon />
          <p className="pl-3 pr-1 text-white">Payment status</p>
          <div className="px-2 py-1 bg-[#FC8E28] rounded-full outline outline-[0.50px] outline-offset-[-0.50px] outline-white inline-flex justify-center items-center gap-1 text-xs font-medium">
            <VerifyIcon />
            Verified
          </div>
        </div>
      </div> */}
      {/* rounded-b-lg */}
      <div className="p-4 pt-2 rounded-lg bg-white space-y-4">
        <Form.Item
          name="tags"
          label="Tags"
          className="mb-4"
          // rules={[
          //   {
          //     required: true,
          //     message: "Please select a tag",
          //   },
          // ]}
        >
          <Select
            placeholder="Select"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            suffixIcon={<SelectDropdownLgIcon />}
            mode="tags"
            options={selectStringOption(getTagData?.data?.tags || [])}
            loading={isTagLoading}
            disabled={type === "view"}
          />
        </Form.Item>
        <span className="text-base text-sub-header block">
          Before you post your job, make sure all details are clear to attract
          the right talent!
        </span>
        {/* <button
          type="button"
          className="text-header underline text-base underline-offset-2"
        >
          See Our Job Policy
        </button> */}
        {type !== "view" && (
          <Button
            htmlType="submit"
            size="large"
            className="w-full"
            type="primary"
          >
            {id ? "Update Job" : "Post Your Job"}
          </Button>
        )}
      </div>
    </div>
  );
}
